import { Container, Graphics } from 'pixi.js';
import { TILE_SIZE } from '../main.js';

/**
 * NPC entity. Non-hostile, stationary, rendered as a colored rectangle with white border.
 */
export class NPC {
  constructor(x, y, config) {
    // config: { name, color, size, dialogue, npcType }
    this.x = x;
    this.y = y;
    this.name = config.name || 'NPC';
    this.color = typeof config.color === 'string' ? parseInt(config.color, 16) : config.color;
    this.size = config.size || 14;
    this.dialogue = config.dialogue || '';
    this.npcType = config.npcType || 'generic';

    this.container = new Container();
    this.gfx = null;
    this.createGraphics();
    this._syncVisual();
  }

  /**
   * Draw the NPC as a colored rectangle with a white border.
   * Uses a rounded shape to visually distinguish from enemies.
   */
  createGraphics() {
    this.gfx = new Graphics();
    const offset = (TILE_SIZE - this.size) / 2;

    // White border (slightly larger)
    this.gfx.rect(offset - 1, offset - 1, this.size + 2, this.size + 2);
    this.gfx.fill(0xffffff);

    // Inner colored body
    this.gfx.rect(offset, offset, this.size, this.size);
    this.gfx.fill(this.color);

    // Small indicator dot on top (to distinguish from enemies)
    const cx = TILE_SIZE / 2;
    this.gfx.circle(cx, offset - 3, 2);
    this.gfx.fill(0xffdd44);

    this.container.addChild(this.gfx);
  }

  /**
   * Check if the player is within interaction range.
   * @param {number} px - Player X position (top-left)
   * @param {number} py - Player Y position (top-left)
   * @param {number} range - Interaction range in pixels
   * @returns {boolean}
   */
  isNearPlayer(px, py, range = 24) {
    const npcCX = this.x + TILE_SIZE / 2;
    const npcCY = this.y + TILE_SIZE / 2;
    const pCX = px + TILE_SIZE / 2;
    const pCY = py + TILE_SIZE / 2;
    const dx = npcCX - pCX;
    const dy = npcCY - pCY;
    return Math.sqrt(dx * dx + dy * dy) <= range;
  }

  _syncVisual() {
    this.container.x = Math.round(this.x);
    this.container.y = Math.round(this.y);
  }
}
